import React from "react";
import { Link } from "react-router-dom"; // optional, if using React Router

const NavButtons = () => {
  return (
    <div className="flex flex-wrap gap-4 p-4 justify-center md:justify-end">
      {/* Register Buttons */}
      <a
        href="/ars/customer/register.php"
        target="_blank"
        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg shadow hover:bg-[#c4122f] hover:text-white transition duration-300"
      >
        Register as Customer
      </a>

      <a
        href="/ars/gaurd/register.php"
        target="_blank"
        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg shadow hover:bg-[#c4122f] hover:text-white transition duration-300"
      >
        Register as Security Guard
      </a>
    </div>
  );
};

export default NavButtons;
